import * as React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Loader } from 'semantic-ui-react';

import { AlphaDetailsSummaryColumns } from '../../shared/data/AlphaDetailsSummaryColumns';
import { SummaryLine } from './Summary/SummaryStatus';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { TypeStage } from './Summary/types';

interface AlphaRiskNeutralizedSummaryProps {
  modifiers?: string[];
  typeStage: TypeStage;
  alpha: any;
  intl: IntlShape;
}

function AlphaRiskNeutralizedSummaryIntl({ alpha, modifiers = [], typeStage }: AlphaRiskNeutralizedSummaryProps) {
  const tableHeader = AlphaDetailsSummaryColumns[typeStage];

  const alphaRecords = alpha && alpha.getIn([typeStage, 'riskNeutralized']);
  const tableInfo = alphaRecords && alphaRecords.toJS();

  if (alpha && !tableInfo) {
    return null;
  } else {
    return (
      <div>
        <div className="summary__header">
          <div className="summary__subtitle">
            <FormattedMessageHelper id={'alphasDetails.settings.riskSummary'} />
          </div>
        </div>
        {!tableInfo ? (
          <div className="loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        ) : (
          <SummaryLine
            tableHeader={tableHeader.summary}
            tableInfo={tableInfo}
            typeStage={typeStage}
            showAccordionArrow={false}
            isTitleHidden={true}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(AlphaRiskNeutralizedSummaryIntl);
